import { createSlice } from "@reduxjs/toolkit";
// eslint-disable-next-line no-duplicate-imports
import type { PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  htmlContent: ""
};

const staticPagesSlice = createSlice({
  name: "staticPages",
  initialState,
  reducers: {
    getHtmlContentSuccess(state, action: PayloadAction<string>) {
      state.htmlContent = action.payload;
    },
    destroy() {
      return initialState;
    }
  }
});

export default staticPagesSlice.reducer;
export const {
  getHtmlContentSuccess,
  destroy
} = staticPagesSlice.actions;
export const staticPagesActions = staticPagesSlice.actions;
